import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import app from 'flarum/forum/app';
import UserPage from 'flarum/forum/components/UserPage';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import CardComponent from './CardComponent';
import OverrideHistoryModal from './OverrideHistoryModal';
import ElementsGuideModal from './ElementsGuideModal';
import StatsOverviewModal from './StatsOverviewModal';
import CustomCardBackRequestModal from './CustomCardBackRequestModal';
import BattlePassBar from './BattlePassBar';
import { BONUS_EFFECT_LABELS, ARENA_CARD_BACKS, getCardBackImage, transPlain } from '../../common';
// Mirrors CreateDeckSlotController::MAX_SLOTS_PER_USER on the backend.
const MAX_DECK_SLOTS = 6;
export default class ArenaProfilePage extends UserPage {
  constructor() {
    super(...arguments);
    _defineProperty(this, "loading", true);
    _defineProperty(this, "saving", false);
    _defineProperty(this, "savingOverride", false);
    _defineProperty(this, "allCards", []);
    _defineProperty(this, "deckCardIds", []);
    _defineProperty(this, "savedDeckCardIds", []);
    _defineProperty(this, "deckSlots", []);
    _defineProperty(this, "selectedDeckSlotId", null);
    _defineProperty(this, "loadingDeckCards", false);
    _defineProperty(this, "slotActionLoading", false);
    _defineProperty(this, "showNewSlotInput", false);
    _defineProperty(this, "newSlotName", '');
    _defineProperty(this, "renamingSlotId", null);
    _defineProperty(this, "renameSlotName", '');
    _defineProperty(this, "filterElementalElement", 'all');
    _defineProperty(this, "filterElementalCost", '');
    _defineProperty(this, "filterBonusCost", '');
    _defineProperty(this, "filterBonusEffect", 'all');
    _defineProperty(this, "hideElementalAdded", false);
    _defineProperty(this, "hideBonusAdded", false);
    _defineProperty(this, "overrideHp", '');
    _defineProperty(this, "overrideMana", '');
    _defineProperty(this, "savingCardBack", false);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.loadUser(m.route.param('username'));
  }
  show(user) {
    super.show(user);
    const overrides = user.attribute('arenaUserOverrides');
    this.overrideHp = (overrides == null ? void 0 : overrides.maxHp) != null ? String(overrides.maxHp) : '';
    this.overrideMana = (overrides == null ? void 0 : overrides.maxMana) != null ? String(overrides.maxMana) : '';
    this.loadData(user);
  }
  async loadData(user) {
    this.loading = true;
    m.redraw();
    try {
      // CardResource's JSON:API index (sorted by `order` server-side) —
      // replaced the raw GET /arena/cards fetch, see extend.php's routes.
      const cards = await app.store.find('arena-cards', {
        page: {
          limit: 500
        }
      });
      this.allCards = (Array.isArray(cards) ? cards : cards ? [cards] : []).filter(c => !!c);
      if (this.canManageDeck()) {
        await this.loadDeckSlots(user);
      }
    } catch (_unused) {
      // fail silently
    } finally {
      this.loading = false;
      m.redraw();
    }
  }
  isDeckDirty() {
    return JSON.stringify([...this.deckCardIds].sort()) !== JSON.stringify([...this.savedDeckCardIds].sort());
  }
  async loadDeckSlots(user) {
    var _this$deckSlots$0$id, _this$deckSlots$;
    try {
      var _response$slots;
      const response = await app.request({
        method: 'GET',
        url: "".concat(app.forum.attribute('apiUrl'), "/arena/deck-slots"),
        params: {
          userId: user.id()
        }
      });
      this.deckSlots = (_response$slots = response == null ? void 0 : response.slots) != null ? _response$slots : [];
    } catch (_unused2) {
      this.deckSlots = [];
    }

    // Every player needs at least one deck slot to build a deck — create the
    // first one automatically for the profile owner (nobody else has the
    // permission, and auto-creating for a viewer wouldn't make sense).
    if (this.deckSlots.length === 0 && this.isProfileOwner()) {
      try {
        const created = await app.request({
          method: 'POST',
          url: "".concat(app.forum.attribute('apiUrl'), "/arena/deck-slots"),
          body: {
            name: app.translator.trans('forumaker-arena.forum.profile.deck.default_slot_name')
          }
        });
        this.deckSlots = [created];
      } catch (_unused3) {
        // fail silently — the user can still create a slot manually below
      }
    }
    this.selectedDeckSlotId = (_this$deckSlots$0$id = (_this$deckSlots$ = this.deckSlots[0]) == null ? void 0 : _this$deckSlots$.id) != null ? _this$deckSlots$0$id : null;
    if (this.selectedDeckSlotId != null) {
      await this.loadSlotCards(this.selectedDeckSlotId);
    }
  }
  async loadSlotCards(slotId) {
    this.loadingDeckCards = true;
    m.redraw();
    try {
      var _response$cardIds;
      const response = await app.request({
        method: 'GET',
        url: "".concat(app.forum.attribute('apiUrl'), "/arena/deck-slots/").concat(slotId, "/cards")
      });
      const ids = (_response$cardIds = response == null ? void 0 : response.cardIds) != null ? _response$cardIds : [];
      this.deckCardIds = [...ids];
      this.savedDeckCardIds = [...ids];
    } catch (_unused4) {
      this.deckCardIds = [];
      this.savedDeckCardIds = [];
    } finally {
      this.loadingDeckCards = false;
      m.redraw();
    }
  }
  async selectSlot(slotId) {
    if (slotId === this.selectedDeckSlotId || this.loadingDeckCards) return;
    if (this.isDeckDirty() && !confirm(transPlain('forumaker-arena.forum.profile.deck.discard_confirm'))) {
      return;
    }
    this.selectedDeckSlotId = slotId;
    await this.loadSlotCards(slotId);
  }
  async createSlot() {
    const name = this.newSlotName.trim();
    if (!name || this.slotActionLoading) return;
    this.slotActionLoading = true;
    m.redraw();
    try {
      const created = await app.request({
        method: 'POST',
        url: "".concat(app.forum.attribute('apiUrl'), "/arena/deck-slots"),
        body: {
          name
        }
      });
      this.deckSlots = [...this.deckSlots, created];
      this.newSlotName = '';
      this.showNewSlotInput = false;
      this.selectedDeckSlotId = created.id;
      this.deckCardIds = [];
      this.savedDeckCardIds = [];
    } catch (e) {
      var _e$response, _body$error;
      const body = (_e$response = e == null ? void 0 : e.response) != null ? _e$response : {};
      app.alerts.show({
        type: 'error'
      }, (_body$error = body == null ? void 0 : body.error) != null ? _body$error : app.translator.trans('forumaker-arena.forum.profile.deck.slot_error'));
    } finally {
      this.slotActionLoading = false;
      m.redraw();
    }
  }
  startRename(slot) {
    this.renamingSlotId = slot.id;
    this.renameSlotName = slot.name;
  }
  cancelRename() {
    this.renamingSlotId = null;
  }
  async confirmRename() {
    if (this.renamingSlotId == null || this.slotActionLoading) return;
    const name = this.renameSlotName.trim();
    if (!name) return;
    const slotId = this.renamingSlotId;
    this.slotActionLoading = true;
    m.redraw();
    try {
      await app.request({
        method: 'PATCH',
        url: "".concat(app.forum.attribute('apiUrl'), "/arena/deck-slots/").concat(slotId),
        body: {
          name
        }
      });
      this.deckSlots = this.deckSlots.map(s => s.id === slotId ? _objectSpread(_objectSpread({}, s), {}, {
        name
      }) : s);
      this.renamingSlotId = null;
    } catch (e) {
      var _e$response2, _body$error2;
      const body = (_e$response2 = e == null ? void 0 : e.response) != null ? _e$response2 : {};
      app.alerts.show({
        type: 'error'
      }, (_body$error2 = body == null ? void 0 : body.error) != null ? _body$error2 : app.translator.trans('forumaker-arena.forum.profile.deck.slot_error'));
    } finally {
      this.slotActionLoading = false;
      m.redraw();
    }
  }
  async deleteSlot(slot) {
    if (this.slotActionLoading) return;
    if (!confirm(transPlain('forumaker-arena.forum.profile.deck.delete_confirm', {
      name: slot.name
    }))) {
      return;
    }
    this.slotActionLoading = true;
    m.redraw();
    try {
      await app.request({
        method: 'DELETE',
        url: "".concat(app.forum.attribute('apiUrl'), "/arena/deck-slots/").concat(slot.id)
      });
      this.deckSlots = this.deckSlots.filter(s => s.id !== slot.id);
      if (this.selectedDeckSlotId === slot.id) {
        var _this$deckSlots$0$id2, _this$deckSlots$2;
        this.selectedDeckSlotId = (_this$deckSlots$0$id2 = (_this$deckSlots$2 = this.deckSlots[0]) == null ? void 0 : _this$deckSlots$2.id) != null ? _this$deckSlots$0$id2 : null;
        if (this.selectedDeckSlotId != null) {
          await this.loadSlotCards(this.selectedDeckSlotId);
        } else {
          this.deckCardIds = [];
          this.savedDeckCardIds = [];
        }
      }
    } catch (e) {
      var _e$response3, _body$error3;
      const body = (_e$response3 = e == null ? void 0 : e.response) != null ? _e$response3 : {};
      app.alerts.show({
        type: 'error'
      }, (_body$error3 = body == null ? void 0 : body.error) != null ? _body$error3 : app.translator.trans('forumaker-arena.forum.profile.deck.slot_error'));
    } finally {
      this.slotActionLoading = false;
      m.redraw();
    }
  }
  isProfileOwner() {
    var _app$session$user, _this$user;
    const sid = (_app$session$user = app.session.user) == null ? void 0 : _app$session$user.id();
    const uid = (_this$user = this.user) == null ? void 0 : _this$user.id();
    return !!sid && !!uid && sid === uid;
  }
  isAdmin() {
    var _app$session$user2;
    return !!((_app$session$user2 = app.session.user) != null && _app$session$user2.attribute('isAdmin'));
  }
  canManageOverrides() {
    const u = app.session.user;
    if (!u) return false;
    return u.attribute('isAdmin') || app.forum.attribute('canManageOverrides');
  }
  canViewDecks() {
    return !!app.forum.attribute('canViewDecks');
  }
  canManageDeck() {
    return this.isProfileOwner() || this.isAdmin() || this.canViewDecks();
  }
  hasActiveBattle() {
    var _this$user2;
    // arenaActiveBattles is a list (a user can have several concurrent
    // battles against different opponents) — an empty array is truthy in
    // JS, so length must be checked explicitly rather than just `!!`.
    const battles = (_this$user2 = this.user) == null ? void 0 : _this$user2.attribute('arenaActiveBattles');
    return !!battles && battles.length > 0;
  }

  // Deck slot ids currently locked in by one of this user's own active
  // battles (see UserResourceFields::arenaActiveBattles — each entry now
  // carries the specific slot that battle used, via ArenaBattle::deckSlotIdFor()).
  // A player can own several decks and only the one actually in a fight is
  // locked — the others remain freely editable.
  lockedDeckSlotIds() {
    var _this$user3;
    const battles = (_this$user3 = this.user) == null ? void 0 : _this$user3.attribute('arenaActiveBattles');
    const ids = (battles != null ? battles : []).map(b => b == null ? void 0 : b.deckSlotId).filter(id => id != null);
    return new Set(ids);
  }
  isSlotLocked(slotId) {
    return slotId != null && this.lockedDeckSlotIds().has(slotId);
  }
  toggleCard(card) {
    var _card$cardType, _card$cardType2;
    if (this.isProfileOwner() && this.isSlotLocked(this.selectedDeckSlotId)) return;
    if (this.selectedDeckSlotId == null) return;
    const id = parseInt(card.id());
    const isBonus = ((_card$cardType = (_card$cardType2 = card.cardType) == null ? void 0 : _card$cardType2.call(card)) != null ? _card$cardType : 'elemental') === 'bonus';
    if (this.deckCardIds.includes(id)) {
      this.deckCardIds = this.deckCardIds.filter(x => x !== id);
    } else {
      const countOfType = this.deckCardIds.filter(did => {
        var _dc$cardType, _dc$cardType2;
        const dc = this.allCards.find(c => parseInt(c.id()) === did);
        return dc && ((_dc$cardType = (_dc$cardType2 = dc.cardType) == null ? void 0 : _dc$cardType2.call(dc)) != null ? _dc$cardType : 'elemental') === 'bonus' === isBonus;
      }).length;
      if (countOfType < 10) {
        this.deckCardIds = [...this.deckCardIds, id];
      }
    }
    m.redraw();
  }
  async saveDeck() {
    if (this.deckCardIds.length > 20 || this.selectedDeckSlotId == null) return;
    const slotId = this.selectedDeckSlotId;
    this.saving = true;
    m.redraw();
    try {
      await app.request({
        method: 'POST',
        url: "".concat(app.forum.attribute('apiUrl'), "/arena/deck"),
        body: {
          cardIds: this.deckCardIds,
          deckSlotId: slotId
        }
      });
      this.savedDeckCardIds = [...this.deckCardIds];
      this.deckSlots = this.deckSlots.map(s => s.id === slotId ? _objectSpread(_objectSpread({}, s), {}, {
        cardCount: this.deckCardIds.length
      }) : s);
      app.alerts.show({
        type: 'success'
      }, app.translator.trans('forumaker-arena.forum.profile.deck.saved'));
    } catch (_unused5) {
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('forumaker-arena.forum.profile.deck.error'));
    } finally {
      this.saving = false;
      m.redraw();
    }
  }
  async saveOverride() {
    var _this$user4;
    const userId = (_this$user4 = this.user) == null ? void 0 : _this$user4.id();
    if (!userId) return;
    this.savingOverride = true;
    m.redraw();
    try {
      var _resp$logErrors;
      const body = {};
      if (this.overrideHp !== '') body.maxHp = parseInt(this.overrideHp) || null;
      if (this.overrideMana !== '') body.maxMana = parseInt(this.overrideMana) || null;
      if (this.overrideHp === '') body.maxHp = null;
      if (this.overrideMana === '') body.maxMana = null;
      const resp = await app.request({
        method: 'POST',
        url: "".concat(app.forum.attribute('apiUrl'), "/arena/users/").concat(userId, "/overrides"),
        body
      });
      await app.store.find('users', userId);
      if (resp != null && (_resp$logErrors = resp.logErrors) != null && _resp$logErrors.length) {
        app.alerts.show({
          type: 'error'
        }, 'Log INSERT error: ' + resp.logErrors[0]);
      } else {
        app.alerts.show({
          type: 'success'
        }, app.translator.trans('forumaker-arena.forum.profile.override.saved'));
      }
    } catch (_unused6) {
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('forumaker-arena.forum.profile.override.error'));
    } finally {
      this.savingOverride = false;
      m.redraw();
    }
  }
  async selectCardBack(id) {
    if (!this.isProfileOwner() || this.savingCardBack) return;
    const user = this.user;
    if (user.attribute('arenaCardBack') === id) return;
    this.savingCardBack = true;
    m.redraw();
    try {
      await user.savePreferences({
        arenaCardBack: id
      });
      m.redraw();
    } catch (_unused7) {
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('forumaker-arena.forum.profile.card_backs.error'));
    } finally {
      this.savingCardBack = false;
      m.redraw();
    }
  }

  /**
   * The "Кастомная" tile's click handler — not a selectCardBack() variant
   * since it doesn't equip anything, it opens a request modal. A pending
   * request short-circuits straight to the "already sent" alert instead of
   * reopening the modal, per the profile-owner-only guard mirrored from
   * selectCardBack() above.
   */
  openCustomCardBackRequest() {
    const user = this.user;
    if (user.attribute('arenaHasPendingCustomCardBackRequest')) {
      app.alerts.show({
        type: 'error'
      }, app.translator.trans('forumaker-arena.forum.profile.card_backs.custom.already_pending'));
      return;
    }
    app.modal.show(CustomCardBackRequestModal, {
      user
    });
  }
  content() {
    var _user$attribute, _currentStats$maxHp, _currentStats$maxMana, _this$selectedDeckSlo;
    if (this.loading) return m(LoadingIndicator, null);
    const user = this.user;
    const stats = (_user$attribute = user.attribute('arenaStats')) != null ? _user$attribute : {
      wins: 0,
      losses: 0,
      draws: 0
    };
    const currentStats = user.attribute('arenaCurrentStats');
    const manaLabel = app.translator.trans('forumaker-arena.lib.stats.mana');
    // This profile owner's card back, applied to their deck/pool cards below.
    const cardBackImage = getCardBackImage(user.attribute('arenaCardBack'));
    const isProfileOwner = this.isProfileOwner();
    const canManage = this.canManageDeck();
    const slotLocked = isProfileOwner && this.isSlotLocked(this.selectedDeckSlotId);
    const deckDisabled = slotLocked || this.selectedDeckSlotId == null || this.loadingDeckCards;
    const deckSet = new Set(this.deckCardIds);
    // Win rate counts only decisive battles (win/loss) — draws don't affect it.
    const decisiveTotal = stats.wins + stats.losses;
    const winrate = decisiveTotal > 0 ? Math.round(stats.wins / decisiveTotal * 100) : 0;
    const dirty = this.isDeckDirty();
    const elementalCards = this.allCards.filter(c => {
      var _c$cardType, _c$cardType2;
      return ((_c$cardType = (_c$cardType2 = c.cardType) == null ? void 0 : _c$cardType2.call(c)) != null ? _c$cardType : 'elemental') !== 'bonus';
    });
    const bonusCards = this.allCards.filter(c => {
      var _c$cardType3, _c$cardType4;
      return ((_c$cardType3 = (_c$cardType4 = c.cardType) == null ? void 0 : _c$cardType4.call(c)) != null ? _c$cardType3 : 'elemental') === 'bonus';
    });
    const deckElementalIds = this.deckCardIds.filter(id => {
      var _dc$cardType3, _dc$cardType4;
      const dc = this.allCards.find(c => parseInt(c.id()) === id);
      return dc && ((_dc$cardType3 = (_dc$cardType4 = dc.cardType) == null ? void 0 : _dc$cardType4.call(dc)) != null ? _dc$cardType3 : 'elemental') !== 'bonus';
    });
    const deckBonusIds = this.deckCardIds.filter(id => {
      var _dc$cardType5, _dc$cardType6;
      const dc = this.allCards.find(c => parseInt(c.id()) === id);
      return dc && ((_dc$cardType5 = (_dc$cardType6 = dc.cardType) == null ? void 0 : _dc$cardType6.call(dc)) != null ? _dc$cardType5 : 'elemental') === 'bonus';
    });
    const filteredElemental = elementalCards.filter(c => {
      if (this.filterElementalElement !== 'all' && c.element() !== this.filterElementalElement) return false;
      if (this.filterElementalCost !== '' && String(c.cost()) !== this.filterElementalCost) return false;
      if (this.hideElementalAdded && deckSet.has(parseInt(c.id()))) return false;
      return true;
    });
    const filteredBonus = bonusCards.filter(c => {
      var _c$bonusEffect, _c$bonusEffect2;
      if (this.filterBonusCost !== '' && String(c.cost()) !== this.filterBonusCost) return false;
      if (this.filterBonusEffect !== 'all' && ((_c$bonusEffect = (_c$bonusEffect2 = c.bonusEffect) == null ? void 0 : _c$bonusEffect2.call(c)) != null ? _c$bonusEffect : '') !== this.filterBonusEffect) return false;
      if (this.hideBonusAdded && deckSet.has(parseInt(c.id()))) return false;
      return true;
    });
    return m("div", {
      className: "ArenaProfilePage"
    }, m("div", {
      className: "ArenaProfilePage-stats"
    }, m("div", {
      className: "ArenaStats"
    }, m("div", {
      className: "ArenaStats-item ArenaStats-item--wins"
    }, m("span", {
      className: "ArenaStats-value"
    }, stats.wins), m("span", {
      className: "ArenaStats-label"
    }, app.translator.trans('forumaker-arena.forum.profile.stats.wins', {
      n: stats.wins
    }))), m("div", {
      className: "ArenaStats-item ArenaStats-item--losses"
    }, m("span", {
      className: "ArenaStats-value"
    }, stats.losses), m("span", {
      className: "ArenaStats-label"
    }, app.translator.trans('forumaker-arena.forum.profile.stats.losses', {
      n: stats.losses
    }))), m("div", {
      className: "ArenaStats-item ArenaStats-item--draws"
    }, m("span", {
      className: "ArenaStats-value"
    }, stats.draws), m("span", {
      className: "ArenaStats-label"
    }, app.translator.trans('forumaker-arena.forum.profile.stats.draws', {
      n: stats.draws
    }))), m("div", {
      className: "ArenaStats-item ArenaStats-item--winrate"
    }, m("span", {
      className: "ArenaStats-value"
    }, winrate, "%"), m("span", {
      className: "ArenaStats-label"
    }, app.translator.trans('forumaker-arena.forum.profile.stats.winrate')))), currentStats && m("div", {
      className: "ArenaStats ArenaStats--vitals"
    }, m("div", {
      className: "ArenaStats-item ArenaStats-item--hp"
    }, m("span", {
      className: "ArenaStats-value"
    }, currentStats.maxHp), m("span", {
      className: "ArenaStats-label"
    }, app.translator.trans('forumaker-arena.lib.stats.hp'))), m("div", {
      className: "ArenaStats-item ArenaStats-item--mana"
    }, m("span", {
      className: "ArenaStats-value"
    }, currentStats.maxMana), m("span", {
      className: "ArenaStats-label"
    }, manaLabel))), m(Button, {
      className: "Button Button--icon ArenaProfilePage-statsOverviewBtn",
      icon: "fas fa-chart-column",
      title: app.translator.trans('forumaker-arena.forum.profile.stats_overview.btn'),
      "aria-label": app.translator.trans('forumaker-arena.forum.profile.stats_overview.btn'),
      onclick: () => app.modal.show(StatsOverviewModal)
    })), m("div", {
      className: "ArenaProfilePage-battlePass"
    }, m(BattlePassBar, {
      games: stats.wins + stats.losses + stats.draws
    })), this.canManageOverrides() && m("div", {
      className: "ArenaProfilePage-section ArenaProfilePage-section--admin"
    }, m("div", {
      className: "ArenaProfilePage-adminHeader"
    }, m("h3", null, m("i", {
      className: "fas fa-user-cog"
    }), " ", app.translator.trans('forumaker-arena.forum.profile.override.title'))), m("p", {
      className: "helpText"
    }, app.translator.trans('forumaker-arena.forum.profile.override.help')), m("div", {
      className: "ArenaProfilePage-overrideGrid"
    }, m("div", {
      className: "Form-group"
    }, m("label", null, m("i", {
      className: "fas fa-heart",
      style: {
        color: 'var(--arena-hp)'
      }
    }), " ", app.translator.trans('forumaker-arena.forum.profile.override.max_hp')), m("input", {
      className: "FormControl",
      type: "number",
      min: 1,
      max: 999,
      value: this.overrideHp,
      placeholder: String((_currentStats$maxHp = currentStats == null ? void 0 : currentStats.maxHp) != null ? _currentStats$maxHp : 15),
      oninput: e => {
        this.overrideHp = e.target.value;
      }
    })), m("div", {
      className: "Form-group"
    }, m("label", null, m("i", {
      className: "fas fa-gem",
      style: {
        color: 'var(--arena-mana)'
      }
    }), ' ', app.translator.trans('forumaker-arena.forum.profile.override.max_mana', {
      mana: manaLabel
    })), m("input", {
      className: "FormControl",
      type: "number",
      min: 1,
      max: 999,
      value: this.overrideMana,
      placeholder: String((_currentStats$maxMana = currentStats == null ? void 0 : currentStats.maxMana) != null ? _currentStats$maxMana : 20),
      oninput: e => {
        this.overrideMana = e.target.value;
      }
    })), m("div", {
      className: "Form-group ArenaProfilePage-overrideHistory"
    }, m("label", null, "\xA0"), m(Button, {
      className: "Button ArenaProfilePage-historyBtn",
      onclick: () => app.modal.show(OverrideHistoryModal, {
        userId: parseInt(user.id()),
        username: user.displayName()
      })
    }, m("i", {
      className: "fas fa-history"
    }), " ", app.translator.trans('forumaker-arena.forum.profile.override.history_btn'))), m("div", {
      className: "Form-group ArenaProfilePage-overrideSave"
    }, m("label", null, "\xA0"), m(Button, {
      className: "Button Button--primary",
      loading: this.savingOverride,
      onclick: () => this.saveOverride()
    }, m("i", {
      className: "fas fa-save"
    }), " ", app.translator.trans('forumaker-arena.forum.profile.override.save_btn'))))), canManage && m('[', null, m("div", {
      className: "ArenaProfilePage-section"
    }, m("div", {
      className: "ArenaProfilePage-sectionHeader",
      style: {
        '--arena-section-accent': 'var(--arena-mana)'
      }
    }, m("div", {
      className: "ArenaProfilePage-sectionIcon"
    }, m("i", {
      className: "fas fa-layer-group"
    })), m("div", {
      className: "ArenaProfilePage-sectionHeading"
    }, m("h3", null, app.translator.trans('forumaker-arena.forum.profile.deck.title')), m("p", {
      className: "ArenaProfilePage-sectionSubtitle"
    }, app.translator.trans('forumaker-arena.forum.profile.deck.subtitle')))), this.deckSlots.length > 0 ? m("div", {
      className: "ArenaProfilePage-deckSlots"
    }, m("div", {
      className: "ArenaProfilePage-deckSlotRow"
    }, isProfileOwner && this.renamingSlotId === this.selectedDeckSlotId ?
    // Renaming edits the same slot in place — this input
    // sits exactly where the <select> normally is, instead
    // of opening a second field further down the page.
    m("input", {
      className: "FormControl ArenaProfilePage-deckSlotInput ArenaProfilePage-deckSlotInput--editing",
      type: "text",
      maxLength: 100,
      value: this.renameSlotName,
      oninput: e => {
        this.renameSlotName = e.target.value;
      },
      onkeydown: e => {
        if (e.key === 'Enter') this.confirmRename();
        if (e.key === 'Escape') this.cancelRename();
      }
    }) : m("select", {
      className: "FormControl ArenaProfilePage-deckSlotInput",
      value: (_this$selectedDeckSlo = this.selectedDeckSlotId) != null ? _this$selectedDeckSlo : '',
      disabled: this.loadingDeckCards || this.slotActionLoading,
      onchange: e => this.selectSlot(parseInt(e.target.value, 10))
    }, this.deckSlots.map(slot =>
    // `selected` set explicitly on the <option> itself,
    // not just `value` on the parent <select>: when a
    // brand-new slot is appended to deckSlots and
    // selected in the very same redraw (createSlot()),
    // the browser can finish creating the new <option>
    // node without picking up the <select>'s value —
    // it kept showing the previously selected deck
    // until some later, unrelated redraw forced the
    // <select> to resync. Setting `selected` directly
    // on the matching option applies regardless of
    // that timing.
    m("option", {
      key: slot.id,
      value: slot.id,
      selected: slot.id === this.selectedDeckSlotId
    }, slot.name))), isProfileOwner && this.selectedDeckSlotId != null && (this.renamingSlotId === this.selectedDeckSlotId ? m('[', null, m(Button, {
      className: "Button Button--icon",
      icon: "fas fa-check",
      title: app.translator.trans('forumaker-arena.forum.profile.deck.save_rename'),
      "aria-label": app.translator.trans('forumaker-arena.forum.profile.deck.save_rename'),
      loading: this.slotActionLoading,
      onclick: () => this.confirmRename()
    }), m(Button, {
      className: "Button Button--icon",
      icon: "fas fa-times",
      title: app.translator.trans('forumaker-arena.forum.profile.deck.cancel'),
      "aria-label": app.translator.trans('forumaker-arena.forum.profile.deck.cancel'),
      disabled: this.slotActionLoading,
      onclick: () => this.cancelRename()
    })) : m('[', null, m(Button, {
      className: "Button Button--icon",
      icon: "fas fa-pen",
      title: app.translator.trans('forumaker-arena.forum.profile.deck.rename_slot'),
      "aria-label": app.translator.trans('forumaker-arena.forum.profile.deck.rename_slot'),
      disabled: this.slotActionLoading,
      onclick: () => {
        const slot = this.deckSlots.find(s => s.id === this.selectedDeckSlotId);
        if (slot) this.startRename(slot);
      }
    }), this.deckSlots.length > 1 && m(Button, {
      className: "Button Button--icon Button--danger",
      icon: "fas fa-trash",
      title: app.translator.trans('forumaker-arena.forum.profile.deck.delete_slot'),
      "aria-label": app.translator.trans('forumaker-arena.forum.profile.deck.delete_slot'),
      disabled: this.slotActionLoading,
      onclick: () => {
        const slot = this.deckSlots.find(s => s.id === this.selectedDeckSlotId);
        if (slot) this.deleteSlot(slot);
      }
    }))), (() => {
      const selected = this.deckSlots.find(s => s.id === this.selectedDeckSlotId);
      if (!selected) return null;
      return m("span", {
        className: "ArenaProfilePage-halfCount ArenaProfilePage-deckSlotBadge ".concat(selected.cardCount === 20 ? 'is-full' : '')
      }, app.translator.trans('forumaker-arena.forum.profile.deck.count_fraction', {
        value: selected.cardCount,
        max: 20
      }));
    })()), isProfileOwner && (this.showNewSlotInput ? m("div", {
      className: "ArenaProfilePage-deckSlotNew"
    }, m("input", {
      className: "FormControl",
      type: "text",
      maxLength: 100,
      placeholder: app.translator.trans('forumaker-arena.forum.profile.deck.new_slot_placeholder'),
      value: this.newSlotName,
      oninput: e => {
        this.newSlotName = e.target.value;
      },
      onkeydown: e => {
        if (e.key === 'Enter') this.createSlot();
      }
    }), m(Button, {
      className: "Button Button--primary",
      loading: this.slotActionLoading,
      onclick: () => this.createSlot()
    }, app.translator.trans('forumaker-arena.forum.profile.deck.create_slot_confirm')), m(Button, {
      className: "Button",
      onclick: () => {
        this.showNewSlotInput = false;
        this.newSlotName = '';
      }
    }, app.translator.trans('forumaker-arena.forum.profile.deck.cancel'))) : this.deckSlots.length < MAX_DECK_SLOTS && m(Button, {
      className: "Button ArenaProfilePage-addSlotBtn",
      onclick: () => {
        this.showNewSlotInput = true;
      }
    }, m("i", {
      className: "fas fa-plus"
    }), " ", app.translator.trans('forumaker-arena.forum.profile.deck.create_slot')))) : m("div", {
      className: "ArenaProfilePage-emptyDeck"
    }, app.translator.trans('forumaker-arena.forum.profile.deck.no_slots')), slotLocked && m("div", {
      className: "ArenaProfilePage-battleLock"
    }, m("i", {
      className: "fas fa-lock"
    }), " ", app.translator.trans('forumaker-arena.forum.profile.battle_lock')), m("div", {
      className: "ArenaProfilePage-deckSplit"
    }, m("div", {
      className: "ArenaProfilePage-deckHalf"
    }, m("div", {
      className: "ArenaProfilePage-deckHalfLabel"
    }, m("i", {
      className: "fas fa-cards"
    }), app.translator.trans('forumaker-arena.forum.profile.deck.elemental_half'), m("span", {
      className: "ArenaProfilePage-halfCount ".concat(deckElementalIds.length === 10 ? 'is-full' : '')
    }, app.translator.trans('forumaker-arena.forum.profile.deck.count_fraction', {
      value: deckElementalIds.length,
      max: 10
    }))), deckElementalIds.length === 0 ? m("div", {
      className: "ArenaProfilePage-emptyDeck"
    }, app.translator.trans('forumaker-arena.forum.profile.deck.add_elemental')) : m("div", {
      className: "ArenaCardGrid ArenaCardGrid--compact ArenaCardGrid--inDeck"
    }, deckElementalIds.map(id => {
      const card = this.allCards.find(c => parseInt(c.id()) === id);
      if (!card) return null;
      return m(CardComponent, {
        key: id,
        card: card,
        selected: true,
        disabled: deckDisabled,
        cardBackImage: cardBackImage,
        onclick: () => this.toggleCard(card)
      });
    }))), m("div", {
      className: "ArenaProfilePage-deckHalf"
    }, m("div", {
      className: "ArenaProfilePage-deckHalfLabel ArenaProfilePage-deckHalfLabel--bonus"
    }, m("i", {
      className: "fas fa-star"
    }), app.translator.trans('forumaker-arena.forum.profile.deck.bonus_half'), m("span", {
      className: "ArenaProfilePage-halfCount ".concat(deckBonusIds.length === 10 ? 'is-full' : '')
    }, app.translator.trans('forumaker-arena.forum.profile.deck.count_fraction', {
      value: deckBonusIds.length,
      max: 10
    }))), deckBonusIds.length === 0 ? m("div", {
      className: "ArenaProfilePage-emptyDeck"
    }, app.translator.trans('forumaker-arena.forum.profile.deck.add_bonus')) : m("div", {
      className: "ArenaCardGrid ArenaCardGrid--compact ArenaCardGrid--inDeck"
    }, deckBonusIds.map(id => {
      const card = this.allCards.find(c => parseInt(c.id()) === id);
      if (!card) return null;
      return m(CardComponent, {
        key: id,
        card: card,
        selected: true,
        disabled: deckDisabled,
        cardBackImage: cardBackImage,
        onclick: () => this.toggleCard(card)
      });
    })))), !slotLocked && m(Button, {
      className: "Button Button--primary Button--block ArenaProfilePage-saveDeckBtn",
      loading: this.saving,
      disabled: !dirty || this.saving || this.selectedDeckSlotId == null,
      onclick: () => this.saveDeck()
    }, app.translator.trans('forumaker-arena.forum.profile.deck.save_btn'))), m("div", {
      className: "ArenaProfilePage-section"
    }, m("div", {
      className: "ArenaProfilePage-sectionHeader",
      style: {
        '--arena-section-accent': '#80b77e'
      }
    }, m("div", {
      className: "ArenaProfilePage-sectionIcon"
    }, m("i", {
      className: "fas fa-cards"
    })), m("div", {
      className: "ArenaProfilePage-sectionHeading"
    }, m("h3", null, app.translator.trans('forumaker-arena.forum.profile.sections.elemental')), m("p", {
      className: "ArenaProfilePage-sectionSubtitle"
    }, app.translator.trans('forumaker-arena.forum.profile.sections.elemental_subtitle', {
      link: m("a", {
        onclick: () => app.modal.show(ElementsGuideModal)
      }, app.translator.trans('forumaker-arena.forum.profile.sections.elemental_subtitle_link'))
    })))), m("div", {
      className: "ArenaProfilePage-filters"
    }, m("select", {
      className: "FormControl",
      value: this.filterElementalElement,
      onchange: e => {
        this.filterElementalElement = e.target.value;
      }
    }, m("option", {
      value: "all"
    }, app.translator.trans('forumaker-arena.forum.profile.filter.all_elements')), ['fire', 'wind', 'lightning', 'earth', 'water'].map(el => m("option", {
      key: el,
      value: el
    }, app.translator.trans("forumaker-arena.lib.elements.".concat(el))))), m("input", {
      className: "FormControl ArenaProfilePage-manaInput",
      type: "number",
      min: "0",
      placeholder: manaLabel,
      value: this.filterElementalCost,
      oninput: e => {
        this.filterElementalCost = e.target.value;
      }
    }), m(Button, {
      className: "Button ArenaProfilePage-hideAdded ".concat(this.hideElementalAdded ? 'active' : ''),
      onclick: () => {
        this.hideElementalAdded = !this.hideElementalAdded;
      },
      title: app.translator.trans('forumaker-arena.forum.profile.filter.hide_added')
    }, m("i", {
      className: "fas ".concat(this.hideElementalAdded ? 'fa-eye' : 'fa-eye-slash')
    }), ' ', this.hideElementalAdded ? app.translator.trans('forumaker-arena.forum.profile.filter.show_all') : app.translator.trans('forumaker-arena.forum.profile.filter.hide_added'))), m("div", {
      className: "ArenaCardGrid"
    }, filteredElemental.map(card => {
      const inDeck = deckSet.has(parseInt(card.id()));
      const sectionFull = deckElementalIds.length >= 10;
      return m(CardComponent, {
        key: card.id(),
        card: card,
        selected: inDeck,
        disabled: deckDisabled || !inDeck && sectionFull,
        cardBackImage: cardBackImage,
        onclick: () => this.toggleCard(card)
      });
    }))), m("div", {
      className: "ArenaProfilePage-section"
    }, m("div", {
      className: "ArenaProfilePage-sectionHeader",
      style: {
        '--arena-section-accent': 'var(--arena-bonus)'
      }
    }, m("div", {
      className: "ArenaProfilePage-sectionIcon"
    }, m("i", {
      className: "fas fa-star"
    })), m("div", {
      className: "ArenaProfilePage-sectionHeading"
    }, m("h3", null, app.translator.trans('forumaker-arena.forum.profile.sections.bonus')), m("p", {
      className: "ArenaProfilePage-sectionSubtitle"
    }, app.translator.trans('forumaker-arena.forum.profile.sections.bonus_subtitle')))), m("div", {
      className: "ArenaProfilePage-filters"
    }, m("select", {
      className: "FormControl",
      value: this.filterBonusEffect,
      onchange: e => {
        this.filterBonusEffect = e.target.value;
      }
    }, m("option", {
      value: "all"
    }, app.translator.trans('forumaker-arena.forum.profile.filter.all_effects')), Object.keys(BONUS_EFFECT_LABELS).map(key => m("option", {
      key: key,
      value: key
    }, app.translator.trans("forumaker-arena.lib.bonus_effects.".concat(key))))), m("input", {
      className: "FormControl ArenaProfilePage-manaInput",
      type: "number",
      min: "0",
      placeholder: manaLabel,
      value: this.filterBonusCost,
      oninput: e => {
        this.filterBonusCost = e.target.value;
      }
    }), m(Button, {
      className: "Button ArenaProfilePage-hideAdded ".concat(this.hideBonusAdded ? 'active' : ''),
      onclick: () => {
        this.hideBonusAdded = !this.hideBonusAdded;
      },
      title: app.translator.trans('forumaker-arena.forum.profile.filter.hide_added')
    }, m("i", {
      className: "fas ".concat(this.hideBonusAdded ? 'fa-eye' : 'fa-eye-slash')
    }), ' ', this.hideBonusAdded ? app.translator.trans('forumaker-arena.forum.profile.filter.show_all') : app.translator.trans('forumaker-arena.forum.profile.filter.hide_added'))), m("div", {
      className: "ArenaCardGrid"
    }, filteredBonus.map(card => {
      const inDeck = deckSet.has(parseInt(card.id()));
      const sectionFull = deckBonusIds.length >= 10;
      return m(CardComponent, {
        key: card.id(),
        card: card,
        selected: inDeck,
        disabled: deckDisabled || !inDeck && sectionFull,
        cardBackImage: cardBackImage,
        onclick: () => this.toggleCard(card)
      });
    })))), isProfileOwner && m("div", {
      className: "ArenaProfilePage-section ArenaProfilePage-cardBacks"
    }, m("div", {
      className: "ArenaProfilePage-sectionHeader",
      style: {
        '--arena-section-accent': '#14b8a6'
      }
    }, m("div", {
      className: "ArenaProfilePage-sectionIcon"
    }, m("i", {
      className: "fas fa-clone"
    })), m("div", {
      className: "ArenaProfilePage-sectionHeading"
    }, m("h3", null, app.translator.trans('forumaker-arena.forum.profile.card_backs.title')), m("p", {
      className: "ArenaProfilePage-sectionSubtitle"
    }, app.translator.trans('forumaker-arena.forum.profile.card_backs.subtitle')))), m("div", {
      className: "ArenaCardBackGrid"
    }, (_ref => {
      const grantedIds = new Set((_ref = user.attribute('arenaGrantedCardBackIds')) != null ? _ref : []);
      return [{
        id: 0,
        imageUrl: null,
        threshold: 0,
        isPublic: true
      }, ...ARENA_CARD_BACKS]
      // "Личная" (isPublic === false) backs come down from the
      // server as one flat list shared by every visitor (there's
      // no per-actor filtering for card backs the way
      // GetCardsController does for cards — see extend.php's
      // arenaCardBacks serializeToForum). Without this filter
      // every player's grid would show every other player's
      // personal design (name + art) as a locked tile, even
      // though only its grantee should ever know it exists.
      .filter(back => back.isPublic !== false || grantedIds.has(back.id));
    })().map(back => {
      var _ref2;
      const selectedBack = (_ref2 = user.attribute('arenaCardBack')) != null ? _ref2 : 0;
      const selected = selectedBack === back.id;
      // "Личная" backs surviving the filter above are always
      // granted, so — unlike public backs — they're never gated by
      // the win threshold (whatever value happens to be stored for
      // one is irrelevant while it's personal; see admin's
      // renderCardBackRow, which hides that field for isPublic === false).
      const locked = back.id !== 0 && back.isPublic !== false && stats.wins < back.threshold;
      return m("div", {
        key: back.id,
        className: ['ArenaCardBackOption', selected ? 'ArenaCardBackOption--selected' : '', locked ? 'ArenaCardBackOption--locked' : ''].filter(Boolean).join(' '),
        onclick: !locked ? () => this.selectCardBack(back.id) : undefined
      }, m("div", {
        className: "ArenaCardBackOption-preview"
      }, back.imageUrl ? m("img", {
        src: back.imageUrl,
        alt: ""
      }) : m("i", {
        className: "fas fa-ban"
      }), locked && m("div", {
        className: "ArenaCardBackOption-lockOverlay"
      }, m("i", {
        className: "fas fa-lock"
      }))), m("div", {
        className: "ArenaCardBackOption-label"
      }, back.id === 0 ? app.translator.trans('forumaker-arena.forum.profile.card_backs.none') : back.name || app.translator.trans('forumaker-arena.forum.profile.card_backs.slot', {
        n: back.id
      })), locked && m("div", {
        className: "ArenaCardBackOption-requirement"
      }, app.translator.trans('forumaker-arena.forum.profile.card_backs.requires_wins', {
        n: back.threshold
      })));
    }), !!app.forum.attribute('arenaShowCustomCardBack') && (() => {
      const pending = !!user.attribute('arenaHasPendingCustomCardBackRequest');
      return m("div", {
        className: "ArenaCardBackOption ArenaCardBackOption--custom".concat(pending ? ' ArenaCardBackOption--pending' : ''),
        onclick: () => this.openCustomCardBackRequest()
      }, m("div", {
        className: "ArenaCardBackOption-preview"
      }, m("i", {
        className: "fas fa-palette"
      })), m("div", {
        className: "ArenaCardBackOption-label"
      }, app.translator.trans('forumaker-arena.forum.profile.card_backs.custom.label')), pending && m("div", {
        className: "ArenaCardBackOption-requirement"
      }, app.translator.trans('forumaker-arena.forum.profile.card_backs.custom.pending')));
    })())));
  }
}
flarum.reg.add('forumaker-arena', 'forum/components/ArenaProfilePage', ArenaProfilePage);